const Self = () => import(/* webpackChunkName: "staff" */ './PrintSelf');
const User = () => import(/* webpackChunkName: "staff" */ './PrintUser');

export default {
  routes: [
    {
      path: '/staff/print/self',
      name: 'staff_print_self',
      component: Self
    },
    {
      path: '/staff/print/user',
      name: 'staff_print_user',
      component: User
    }
  ]
}
